module.exports = __webpack_public_path__ + "static/media/user.ad6f494c.svg";